<div class="widget-content-container toennies-blog-widget">
  @if (dataLoading) {
    <iq-loading-indicator></iq-loading-indicator>
  }
  @if (!dataLoading) {
    <div class="blog-content">
      @if (isBlogPostsLoaded) {
        <div class="content-wrapper">
          <div class="posts-container">
            @for (post of posts; track post) {
              <div class="post">
                <div class="post-date">
                  <span>{{ post.date | date: 'd MMM' | uppercase }}</span>
                </div>
                <div>
                  <a class="post-title" [href]="post.link" target="_blank">{{ post.title }}</a>
                  <p class="post-content">{{ post.content }}</p>
                </div>
              </div>
            }
          </div>
          <div class="to-blog">
            <a class="btn blog-btn" href="https://toennies-agrarblog.de/aktuelle-nachrichten" target="_blank">{{
              'WIDGETS.TOENNIES_AGRARBLOG.BUTTON_TEXT' | translate | uppercase
            }}</a>
          </div>
        </div>
      }
      @if (!isBlogPostsLoaded) {
        <div class="blog-unavailable">
          <div class="message-container">
            <span>{{ 'WIDGETS.TOENNIES_AGRARBLOG.BLOG_UNAVAILABLE' | translate }}</span>
          </div>
        </div>
      }
    </div>
  }
</div>
